import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import regPlate from '../../../assets/img/logo/gb-plate.jpg';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '2px',
        backgroundColor: theme.palette.light[100],
        '& svg': {
          color: theme.palette.dark[500],
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${theme.palette.dark[300]}`,
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.common.black,
      },
      '& .MuiOutlinedInput-input': {
        color: theme.palette.dark[800],
      },
      '& .MuiOutlinedInput-root.Mui-focused': {
        backgroundColor: theme.palette.light[100],
      },
      '& .MuiInputBase-root.Mui-disabled': {
        backgroundColor: theme.palette.light[200],
        borderColor: theme.palette.light[900],
      },
      '& div.Mui-error': {
        borderColor: theme.palette.utility.redLight,
        boxShadow: `inset 0 0 0 4px ${theme.palette.utility.redDark}`,
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
          borderColor: `${theme.palette.utility.redLight}`,
        },
      },
    },
    textFieldEnabled: {
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.dark[300],
      },
    },
    vehicleLookup: {
      backgroundImage: `url(${regPlate})`,
      backgroundPosition: '0px 50%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '32px',
      paddingLeft: '50px',
    },
  }),
);
